const ACTION_PREFIX = '@komigen/exclusive-game-widgets';

export const EXCLUSIVE_GAME_WIDGET_SUBSCRIBE = `${ACTION_PREFIX}/SUBSCRIBE`;
export const EXCLUSIVE_GAME_WIDGET_UNSUBSCRIBE = `${ACTION_PREFIX}/UNSUBSCRIBE`;
export const EXCLUSIVE_GAME_WIDGET_UPDATE_SUBSCRIPTIONS = `${ACTION_PREFIX}/UPDATE_SUBSCRIPTIONS`;
export const EXCLUSIVE_GAME_WIDGET_TOGGLE_MODAL_OPEN = `${ACTION_PREFIX}/TOGGLE_MODAL_OPEN`;
